<template>
    <!-- Modal -->
    <div class="modal fade" :id="modal_name" tabindex="-1" role="dialog" aria-labelledby="modelTitleId" aria-hidden="true">
        <div class="modal-dialog modal-xl modal-dialog-scrollable" role="document">
            <div class="modal-content">
                <div class="modal-header">
                    <h5 class="modal-title">Etiqueta</h5>
                    <button type="button" class="close" data-dismiss="modal" aria-label="Close">
                        <span aria-hidden="true">&times;</span>
                    </button>
                </div>
                <div class="modal-body">
                    <az-empty-state
                        v-if="!etiqueta_layouts || !etiqueta_layouts.length"
                        msg="Nenhum layout de etiqueta cadastrado." />

                    <template v-else>
                        <az-input
                            icon="fa fa-tags fa-fw"
                            label="Selecione o Layout"
                            placeholder="Selecione o Layout..."
                            type="select"
                            :optionsList="etiqueta_layouts"
                            optionsData="id_etiqueta_layout"
                            optionsDisplay="search"
                            v-model="layout" />

                        <div v-if="layout_selecionado && layout_selecionado.ch_tipo_impressao == 'S'">
                            <az-input
                                icon="fa-solid fa-print fa-fw"
                                placeholder="Servidor de Impressão..."
                                v-model="servimp" />
                        </div>

                        <table class="table table-sm mt-3">
                            <thead>
                                <tr>
                                    <th class="text-center">
                                        <a href="#" @click.prevent="toggle_selec_all">
                                            <i class="fa fa-square fa-fw" aria-hidden="true"></i>
                                        </a>
                                    </th>
                                    <th>Item</th>
                                    <th>Lote</th>
                                    <th>Validade</th>
                                    <th>Quantidade</th>
                                </tr>
                            </thead>
                            <tbody>
                                <tr v-for="(item, icx) in lista" :key="icx">
                                    <td style="width: 25px;" class="text-center">
                                        <input
                                            class="text-nowrap text-truncate w-10"
                                            type="checkbox"
                                            v-model="item.checked"
                                        />
                                    </td>
                                    <td>
                                        <label
                                            class="form-control text-nowrap text-truncate bg-light"
                                        >
                                            <small>{{ item.search }}</small>
                                        </label>
                                    </td>
                                    <td>
                                        <label class="form-control text-nowrap text-truncate bg-light">
                                            <small>{{ item.lote }}</small>
                                        </label>
                                    </td>
                                    <td>
                                        <label class="form-control text-nowrap text-truncate bg-light">
                                            <small>{{
                                                item.validade
                                                    ? $util.getFormatDate(
                                                          item.validade
                                                      )
                                                    : ""
                                            }}</small>
                                        </label>
                                    </td>
                                    <td style="width: 150px;">
                                        <az-input
                                            type="number"
                                            v-model="item.qtde">
                                        </az-input>
                                    </td>
                                </tr>
                            </tbody>
                        </table>
                    </template>
                </div>
                <div class="modal-footer">
                    <button type="button" class="btn btn-secondary" data-dismiss="modal">
                        Fechar
                    </button>
                    <az-submit v-if="layout" @click="imprimir_etiqueta()">Imprimir</az-submit>
                </div>
            </div>
        </div>
    </div>
</template>

<script>
import $ from "jquery";
import _ from "lodash";
import AzInput from "../../shared/forms/AzInput.vue";
import AzSubmit from '../../util/AzSubmit.vue';

export default {
    data() {
        return {
            dados: null,
            etiqueta_layouts: [],
            layout: null,
            servimp: "", 
        };
    },

    props: ['sufixo'],

    components: {
        AzInput,
        AzSubmit
    },

    computed: {
        lista: function() {
            if (!this.dados) return [];

            return this.dados;
        },

        modal_name: function () { 
            return 'emitirEstoqueEtiquetaModal' + (this.sufixo ? this.sufixo : '');
        },

        layout_selecionado: function() { 
            if (!this.etiqueta_layouts || !this.etiqueta_layouts.length) return null;

            return this.etiqueta_layouts.find(item => item.id_etiqueta_layout == this.layout);
        }
    },

    methods: {
        toggle_selec_all () { 
            let selec = this.lista.filter(item => item.checked).length != this.lista.length;
            this.lista.forEach(item => item.checked = selec);
        },

        load() {
            this.etiqueta_layouts = [];

            this.$util.load(this, {
                service: "etiqueta_layouts",
                func: "index",
                parms: {
                    where: {
                        st_model_type: "App\\azure\\estoqueLote", 
                        fl_ativo: 1
                    }
                },
                loadTo: res => {
                    this.etiqueta_layouts = res;

                    if (res && res.length == 1)
                        this.layout = res[0].id_etiqueta_layout;
                    else
                        this.layout = this.$util.getCookie(
                            "etiqueta-layout-" + this.modelo
                        );
                }
            });
        },

        show(items) {
            this.dados = _.cloneDeep(items);

            this.load();

            $("#" + this.modal_name).modal("show");
        },

        imprimir_etiqueta() {
            const items = this.lista.filter(item => item.checked);
            if(!items.length) {
                this.$toast.add({
                    severity: "error",
                    summary: "Atualizar",
                    detail: 'Selecione ao menos um item.',
                    life: 3000
                });
                return;
            }

            this.$util.atualizar(this, {
                service: "estoque_items",
                func: "imprimir_etiqueta",
                dados: {
                    items: items,
                    id_etiqueta_layout: this.layout,
                    servimp: this.servimp, 
                },
                modal: this.modal_name,
                toast: false,
                callback: res => {
                    if (res.status == "OK") {
                        let pdfWindow = window.open("");
                        pdfWindow.document.write(
                            "<html><head><title>Etiqueta de Amostra</title></head><body><iframe width='100%' height='100%' src='data:application/pdf;base64, " +
                                encodeURI(res.resposta) +
                                "'></iframe></body></html>"
                        );
                    } else {
                        this.$toast.add({
                            severity: "error",
                            summary: "Atualizar",
                            detail: res.mensagem,
                            life: 3000
                        });
                    }
                }
            });
        }
    }
};
</script>
